import React, { Component } from 'react';
import { __, __n } from 'i18n/index';
import { ChatActions } from 'components/ChatActions';
import { ChatRoom } from 'models/ChatRoom';
import GameTileGrid from 'react/elements/GameTileGrid';
import { roomColorStyle } from 'functions/roomColors';

import { CircleLoaderComponent } from 'react/CircleLoaderComponent';

const SEARCH_DELAY_MS = 200;

// "Browse Rooms": search public rooms by name or id and pick one to join it,
// or create a new room with the typed name. Rooms are joined by id; two rooms
// can share a name, so creating never joins an existing room.
export default class JoinChatPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			results: null,
			searching: false,
			loadingFeaturedChats: false,
		};
		this.onChange = this.chatChange.bind(this);
		this.chatRoomSelected = this.chatRoomSelected.bind(this);
		this.createRoom = this.createRoom.bind(this);
		this.searchTimer = null;
		this.latestQuery = '';
	}

	componentDidMount() {
		if(!ChatRoom.recentChats.size) {
			this.setState({
				loadingFeaturedChats: true
			});
			ChatActions.loadFeaturedChats()
				.then(() => {
					this.forceUpdate();
				})
				.finally(() => {
					this.setState({
						loadingFeaturedChats: false
					});
				});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.searchTimer);
		this.unmounted = true;
	}

	chatRoomSelected(event, chatRoom) {
		event.preventDefault();
		chatRoom.setActive(event);
		this.props.dismiss();
	}

	joinSearchResult(room) {
		ChatActions.joinChatRoomById(room.id);
		this.props.dismiss();
	}

	createRoom() {
		const name = this.state.value.trim();
		if(!name) {
			return;
		}
		ChatActions.createChatRoom(name);
		this.props.dismiss();
	}

	chatChange(event) {
		const value = event.target.value;
		this.setState({ value });
		clearTimeout(this.searchTimer);
		const query = value.trim();
		this.latestQuery = query;
		if(!query) {
			this.setState({ results: null, searching: false });
			return;
		}
		this.setState({ searching: true });
		this.searchTimer = setTimeout(() => {
			Promise.resolve(ChatActions.searchRooms(query))
				.then((rooms) => {
					if(!this.unmounted && this.latestQuery === query) {
						this.setState({ results: rooms || [], searching: false });
					}
				})
				.catch(() => {
					if(!this.unmounted && this.latestQuery === query) {
						this.setState({ results: [], searching: false });
					}
				});
		}, SEARCH_DELAY_MS);
	}

	renderResults() {
		const { value, results, searching } = this.state;
		const name = value.trim();
		return (
			<div className='room_search_results'>
				{searching && results === null && <CircleLoaderComponent />}
				{results && results.length === 0 && !searching &&
					<span className='no_chats'>{__('No public rooms match.')}</span>
				}
				{results && results.length > 0 &&
					<ul className='room_search_list'>
						{results.map((room) => (
							<li key={room.id}>
								<button type='button' className='room_search_result' onClick={() => this.joinSearchResult(room)}>
									<span className='room_search_dot' style={roomColorStyle(room.colors)} aria-hidden='true' />
									<span className='room_search_name'>{room.name}</span>
									<span className='room_search_meta'>#{room.id} · {__n('%d member', '%d members', room.members, room.members)}</span>
								</button>
							</li>
						))}
					</ul>
				}
				<button type='button' className='btn create_room_button' onClick={this.createRoom}>
					{`${__('Create a room named')} "${name}"`}
				</button>
			</div>
		);
	}

	render() {
		const { value, loadingFeaturedChats } = this.state;
		const featuredItems = Array.from(ChatRoom.recentChats.values()).map((chatRoom) => ({
			key: chatRoom.id,
			label: chatRoom.name || `#${chatRoom.id}`,
			image: chatRoom.ladder ? chatRoom.ladder.smallImageUrl() : null,
			href: chatRoom.getUrl(),
			style: roomColorStyle(chatRoom.colors),
			onClick: (event) => this.chatRoomSelected(event, chatRoom),
		}));

		return (
			<div className='join_chat'>
				<h6>{__('Find a room')}</h6>
				<input onChange={this.onChange} placeholder={__('Room name or #id')} type='search' value={value} />
				{value.trim() !== '' && this.renderResults()}
				{value.trim() === '' &&
					<div className='suggested_chats'>
						{loadingFeaturedChats &&
							<CircleLoaderComponent/>
						}
						{!loadingFeaturedChats && featuredItems.length > 0 &&
							<GameTileGrid items={featuredItems} />
						}
						{!loadingFeaturedChats && featuredItems.length === 0 &&
							<span className='no_chats'>{__('No Chats to Display...')}</span>
						}
					</div>
				}
			</div>

		);
	}
}
